export const CHECKOUT_URL =
  'https://checkout.mecanicocheck.shop/checkouts/cn/hWNDD0K45Z5kWndlVrK2d7uj/es-ar?_r=AQABZo0SzsR-maU_-Ce-YF3NhBhzxotP3L40-W6kszNeNoE'

export const META_PIXEL_ID = '2064376784189174'
